function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#BFB7B6",
  d: "M13.498 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2.953 4.658l-.728-.368-.303-.92c-.46-1.393-1.74-2.367-3.193-2.37-1.125-.004-1.747.315-2.916.787a2.98 2.98 0 00-1.553 1.443l-.209.425a1.003 1.003 0 00.444 1.34.986.986 0 001.328-.446l.21-.425a.987.987 0 01.515-.481l.837-.338-.475 1.897c-.162.65.013 1.34.466 1.837l1.871 2.044c.225.246.385.543.466.865l.572 2.29a1 1 0 001.94-.484l-.694-2.78a1.999 1.999 0 00-.465-.866l-1.422-1.553.537-2.147.172.516c.166.503.522.918.99 1.156l.729.369a.986.986 0 001.328-.447c.24-.49.044-1.097-.447-1.344zm-7.152 4.396c-.1.254-.25.482-.444.672l-1.562 1.566c-.39.39-.39 1.025 0 1.415a.998.998 0 001.412 0l1.856-1.856c.19-.19.34-.419.444-.672l.422-1.056c-1.728-1.884-1.21-1.306-1.481-1.678l-.647 1.61z"
});

function SvgPedestrian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgPedestrian;